module.exports = __webpack_public_path__ + "static/Mobile Reg 3-33008d3693882e26d07afd21e6ddbba8.png";